import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { i18n } from "../../translate/i18n";

export function LastMessageFilter({ onFiltered }) {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    async function fetchData() {}
    fetchData();
  }, []);

  const onChange = async (value) => {
    setSelected(value);
    onFiltered(value);
  };

  const options = [
    {
      value: "all",
      label: i18n.t("lastMessageFilter.all"),
    },
    {
      value: "operator",
      label: i18n.t("lastMessageFilter.operator"),
    },
    {
      value: "client",
      label: i18n.t("lastMessageFilter.client"),
    },
  ];

  return (
    <Box style={{ padding: "0px 10px 10px" }}>
      <Autocomplete
        size="small"
        options={options}
        value={selected}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={i18n.t("lastMessageFilter.placeholder")}
          />
        )}
      />
    </Box>
  );
}
